import { Button, Menu } from '@material-ui/core'
import { MenuItem } from 'material-ui'
import React, { useState } from 'react'
import injectStyles from 'react-jss'
import MenuDots from '../../../Assets/Images/icons/menuDots'
import PenIcon from '../../../Assets/Images/icons/PenIcon'
import {
  STATUS_DOCUMENT_APPROVED,
  STATUS_DOCUMENT_MANUALY_APPLOADED,
} from '../../../shared/constants'
import styles from './styles'

const ActionBlock = ({
  document,
  onMakePrimary,
  onDelete,
  onEdit,
  onSave,
  classes,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div className={classes.container}>
      {document.isEdit ? (
        <div
          className={classes.saveButton}
          onClick={async () => await onSave(document)}
        >
          Save
        </div>
      ) : (
        <div
          className={classes.editButton}
          onClick={async () => await onEdit(document)}
        >
          <PenIcon />
        </div>
      )}
      <div className={classes.statusButtonsContainer}>
        <Button
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          {<MenuDots />}
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem onClick={handleClose}>
            <a
              href={document.url}
              className={classes.link}
              target="_blank"
              download
              rel="noreferrer"
            >
              Download
            </a>
          </MenuItem>
          <MenuItem
            onClick={async () => {
              await onDelete({ document })
              handleClose()
            }}
          >
            Delete
          </MenuItem>
          {!document.isPrimary &&
          (document.status == STATUS_DOCUMENT_APPROVED ||
            document.status == STATUS_DOCUMENT_MANUALY_APPLOADED) ? (
            <MenuItem
              onClick={async () => {
                await onMakePrimary(document)
                handleClose()
              }}
            >
              Set as primary
            </MenuItem>
          ) : null}
        </Menu>
      </div>
    </div>
  )
}

export default injectStyles(styles)(ActionBlock)
